<template>
  <v-container>
    <v-card class="mx-auto pa-4">
      <p class="display-1 text--primary">
        Sold Items

      </p>
      <v-data-table dense :headers="headers" :options.sync="options" :must-sort=true :items="this.soldItems"
        :server-items-length="(this.soldItems.length)" :footer-props="{
          itemsPerPageOptions: [-1]
        }" loading-text="Loading...please wait" :loading="this.loading">

        <template v-slot:item.title="{ item }">
          <a :href="item.link" target="_blank">{{ item.title }}</a>
        </template>

        <template v-slot:item.salePrice="{ item }">
          <span style="white-space: nowrap;"> {{ item.salePrice | toCurrency(0) }}</span>
        </template>

        <template v-slot:item.shippingPrice="{ item }">
          <span style="white-space: nowrap;"> {{ item.shippingPrice | toCurrency(0) }}</span>
        </template>

        <template v-slot:item.delete="{ item }">
          <v-icon small color="error" class="pa-1" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>

      </v-data-table>
    </v-card>

    <ConfirmationDialog ref="confirm" />

  </v-container>
</template>

<script>
import { SellersService } from '../../services/api/sellers';
const apiSellerService = new SellersService();
import { SoldItemsService } from '../../services/api/soldItems';
const apiSoldItems = new SoldItemsService();


export default {
  components: {
    ConfirmationDialog: () => import("../confirmation-dialog")
  },
  props:
  {
    loading: Boolean,
    soldItems: Array
  },

  data() {
    return {
      options: {},
      headers: [
        // HACK:  use ' d-none' (note the leading space) to hide the column.
        { text: 'ID', value: 'id', hidden: true, align: ' d-none' },

        { text: 'Seller', value: 'sellerName' },

        { text: 'Title', value: 'title' },
        { text: 'Sale Price', value: 'salePrice', align: 'end' },
        { text: 'Shipping Price', value: 'shippingPrice', align: 'end' },
        { text: 'Condition', value: 'condition' },
        { text: 'Buying Format', value: 'buyingFormat' },
        { text: 'DateSold', value: 'dateSold' },
        { text: 'Location', value: 'location' },
        { text: 'Seller Feedback Count', value: 'sellerFeedbackCount' },
        { text: 'Seller Feedback Percent', value: 'sellerFeedbackPercent' },

        { text: 'Delete', value: 'delete', align: 'center', sortable: false }
      ],
    }
  },

  watch: {
    options(newVal) {
      console.log("options changed:", newVal);
      let sortBy = null;
      let sortDesc = false;
      if (newVal && Array.isArray(newVal.sortBy) && newVal.sortBy.length > 0) {
        sortBy = newVal.sortBy[0];
      }
      if (newVal && Array.isArray(newVal.sortDesc) && newVal.sortDesc.length > 0) {
        sortDesc = newVal.sortDesc[0];
      }
      this.$emit('update:options', { 
        sortBy,
        sortDesc
      });
    }
  },

  methods: {
    async deleteItem(item) {
      // If the user confirms deletion, then:
      if (await this.$refs.confirm.open(
        "Confirm Delete",
        "Delete this Sold Item?",
        { okText: "Delete", okColor: "error" })) {


        apiSoldItems.deleteSoldItem(item.id).then((data) => {
          // remove the item in question from our data.
          const index = this.items.indexOf(item);
          if (index > -1) {
            this.items.splice(index, 1);

            // Alert any parent components that the Snapshot's listing values have changed.
            this.$emit('soldItems-changed');
          }
        });
      }
    },
  }
}
</script>